import gql from 'graphql-tag'

const minhasEmpresas = gql`
  query {
    minhasEmpresas(page:{limit:1000, offset:0}) {
      id
      razaoSocial
      cnpj
      tipo
      inscricaoEstadual
      criadaEm
    }
  }
`
export default minhasEmpresas
